// Third Party Libraries Imports
import { Collapse } from "antd";

// Style Imports
import '../styles/collapse-component.style.scss'

type CollapseProps = {
  header: React.ReactNode;
  children: React.ReactNode;
};

const randomKey: number = Math.random();

const CollapseComponent: React.FC<CollapseProps> = ({
  header,
  children,
}: CollapseProps) => {
  return (
    <Collapse
      expandIconPosition="end"
      className="mb-7"
      destroyInactivePanel={true}
      defaultActiveKey={randomKey}
      expandIcon={(panelProps) => {
        return panelProps?.isActive ? (
          <img src="/images/collapse-icon.svg" />
        ) : (
          <img src="/images/collapse-icon.svg" className=" rotate-180" />
        );
      }}
      items={[
        {
          key: randomKey,
          label: header,
          children: children,
        },
      ]}
    />
  );
};

export default CollapseComponent;
